// Port of api/fuel/app/classes/insights/collection/dependencies.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'dependencies',
    insight: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var band = (vars && vars.band !== undefined) ? vars.band : 0

        var dependencies = []

        for (var i = 1; i <= 5; i++) {
            dependencies.push({ i: i, g: 0, f: 0 })
        }

        if (detail) {

            var raw = Util.queryFast('\
                SELECT \
                    g.game_id AS g \
                FROM \
                    collection c \
                    JOIN \
                    game g \
                    ON \
                    c.game_id = g.game_id \
                WHERE \
                    c.user_id IN (' + Util.in(userIndex) + ') \
                    AND \
                    c.collection_own = 1 \
                    AND \
                    c.collection_expansion = 0 \
                    AND \
                    g.game_language_dependency = ' + band + ' \
                GROUP BY \
                    g.game_id \
                ORDER BY \
                    g.game_sortname ASC \
            ')

            var games = []

            for (var ri = 0; ri < raw.length; ri++) {
                this._references.games.push(parseInt(raw[ri].g, 10))

                games.push({
                    id: parseInt(raw[ri].g, 10)
                })
            }

            return {
                games: games
            }

        } else {

            var rawGroup = Util.queryFast('\
                SELECT \
                    group_concat(DISTINCT c.game_id ORDER BY c.game_id ASC) as i, \
                    COUNT(DISTINCT c.game_id) AS g, \
                    g.game_language_dependency AS d \
                FROM \
                    collection c \
                    JOIN \
                    game g \
                    ON \
                    c.game_id = g.game_id \
                WHERE \
                    g.game_language_dependency > 0 \
                    AND \
                    c.user_id IN (' + Util.in(userIndex) + ') \
                    AND \
                    c.collection_own = 1 \
                    AND \
                    c.collection_expansion = 0 \
                GROUP BY \
                    g.game_language_dependency \
            ')

            for (var gi = 0; gi < rawGroup.length; gi++) {
                var item = rawGroup[gi]

                var featured = item.i
                    .split(',')
                    .map(function(id) { return parseInt(id, 10) })
                    .filter(function(id) { return id > 0 })
                    .sort(function(a, b) { return a - b })[0] || 0

                dependencies[item.d - 1].g = parseInt(item.g, 10)
                dependencies[item.d - 1].f = featured
            }

            return {
                dependencies: dependencies.slice().reverse()
            }

        }

    }
})
